var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92.1185,
    height: 92.1185,
    transform: "translate(0.202148 -0.000488281)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3436 25.0762H57.4917C62.4491 25.0762 66.4641 29.0912 66.4641 34.0486V57.1968C66.4641 62.1541 62.4491 66.1692 57.4917 66.1692H34.3436C29.3862 66.1692 25.3711 62.1541 25.3711 57.1968V34.0486C25.3711 29.0912 29.3862 25.0762 34.3436 25.0762Z",
    fill: "url(#paint0_linear_719_2295)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7949 27.2898H35.0398C30.9018 27.2898 27.5422 30.6493 27.5422 34.7873V56.5425C27.5422 60.6805 30.9018 64.04 35.0398 64.04H56.7949C60.9329 64.04 64.2924 60.6805 64.2924 56.5425V34.7464C64.2924 30.6084 60.9329 27.2898 56.7949 27.2898ZM63.6779 56.6244C63.6779 60.3937 60.6461 63.4255 56.8769 63.4255H34.9578C31.2295 63.4255 28.1568 60.3937 28.1568 56.6244V34.6644C28.1568 30.8952 31.1886 27.8634 34.9578 27.8634H56.9178C60.6461 27.8634 63.7189 30.8952 63.7189 34.6644V56.6244H63.6779Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9787 28.7637C36.7194 28.7637 29.1809 36.3022 29.1809 45.5614C29.1809 54.8207 36.7194 62.3592 45.9787 62.3592C55.2789 62.3592 62.7764 54.8207 62.7764 45.5614C62.7764 36.3022 55.2379 28.7637 45.9787 28.7637ZM45.9787 62.1134C36.8423 62.1134 29.4267 54.6978 29.4267 45.5614C29.4267 36.4251 36.8423 29.0095 45.9787 29.0095C55.115 29.0095 62.5306 36.4251 62.5306 45.5614C62.5306 54.6978 55.115 62.1134 45.9787 62.1134Z",
    fill: "#69C5F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9788 32.2061C38.5632 32.2061 32.5815 38.1877 32.5815 45.6033C32.5815 53.0189 38.5632 58.9596 45.9788 58.9596C53.3944 58.9596 59.376 52.9779 59.376 45.5623C59.376 38.1467 53.3534 32.2061 45.9788 32.2061ZM45.9788 58.6728C38.7271 58.6728 32.8683 52.814 32.8683 45.5623C32.8683 38.3106 38.7271 32.4519 45.9788 32.4519C53.2305 32.4519 59.0892 38.3106 59.0892 45.5623C59.0892 52.814 53.1895 58.6728 45.9788 58.6728Z",
    fill: "#68C5F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1551 48.634H58.7204C59.7857 48.634 60.6051 49.4944 60.6051 50.5187C60.6051 51.5839 59.7447 52.4033 58.7204 52.4033H33.1551C32.0899 52.4033 31.2704 51.5429 31.2704 50.5187C31.2295 49.4944 32.0899 48.634 33.1551 48.634Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0733 49.0029H58.7206C59.54 49.0029 60.2365 49.6585 60.2365 50.5188V50.5598C60.2365 51.3792 59.5809 52.0757 58.7206 52.0757H33.0733C32.2539 52.0757 31.5574 51.4202 31.5574 50.5598V50.4779C31.5983 49.6585 32.2539 49.0029 33.0733 49.0029Z",
    fill: "#0A93E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4585 51.912H59.3759L59.5807 51.7891H32.2537L32.4585 51.912Z",
    fill: "#1694EA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8441 51.42H59.9497L60.0316 51.2971H31.7622L31.8441 51.42Z",
    fill: "#319DEC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5981 50.6414H60.2363V50.4775H31.5981V50.6414Z",
    fill: "#65B1EE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8849 49.6177H59.9904L60.0314 49.6996L60.0724 49.7816H31.803L31.8439 49.6996L31.8849 49.6177Z",
    fill: "#8EC6F3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4995 49.126H59.3759L59.4988 49.1669L59.6217 49.2489H32.2537L32.3766 49.1669L32.4995 49.126Z",
    fill: "#95CAF3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9832 49.0029H57.7783C57.7783 49.0029 58.4748 49.4946 58.4748 50.6008C58.4748 51.625 57.7783 52.0757 57.7783 52.0757H57.9832C57.9832 52.0757 58.6797 51.7479 58.6797 50.6008C58.6797 49.3717 57.9832 49.0029 57.9832 49.0029Z",
    fill: "url(#paint1_linear_719_2295)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0164 49.0029H55.8115C55.8115 49.0029 56.4261 49.5765 56.4261 50.6008C56.4261 51.5021 55.8115 52.0757 55.8115 52.0757H56.0164C56.0164 52.0757 56.6309 51.625 56.6309 50.6008C56.59 49.4946 56.0164 49.0029 56.0164 49.0029Z",
    fill: "url(#paint2_linear_719_2295)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8149 49.0029H46.0198V52.0757H45.8149V49.0029Z",
    fill: "url(#paint3_linear_719_2295)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8073 49.0029H44.0121C44.0121 49.0029 43.9302 49.7814 43.9302 50.6008C43.9302 51.3382 44.0121 52.0757 44.0121 52.0757H43.8073C43.8073 52.0757 43.7253 51.3382 43.7253 50.6008C43.7253 49.7814 43.8073 49.0029 43.8073 49.0029Z",
    fill: "url(#paint4_linear_719_2295)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8408 49.0029H42.0457C42.0457 49.0029 41.8408 49.7814 41.8408 50.6008C41.8408 51.3382 42.0457 52.0757 42.0457 52.0757H41.8408C41.8408 52.0757 41.636 51.3382 41.636 50.6008C41.636 49.7814 41.8408 49.0029 41.8408 49.0029Z",
    fill: "url(#paint5_linear_719_2295)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8332 49.0029H40.038C40.038 49.0029 39.7512 49.7814 39.7512 50.6008C39.7512 51.3382 40.038 52.0757 40.038 52.0757H39.8332C39.8332 52.0757 39.5464 51.3382 39.5464 50.6008C39.5464 49.7814 39.8332 49.0029 39.8332 49.0029Z",
    fill: "url(#paint6_linear_719_2295)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8257 49.0029H38.0306C38.0306 49.0029 37.6209 49.6585 37.6209 50.6008C37.6209 51.4202 38.0306 52.0757 38.0306 52.0757H37.8257C37.8257 52.0757 37.416 51.4202 37.416 50.6008C37.416 49.6585 37.8257 49.0029 37.8257 49.0029Z",
    fill: "url(#paint7_linear_719_2295)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8182 49.0029H36.023C36.023 49.0029 35.4085 49.5765 35.4085 50.6008C35.4085 51.5021 36.023 52.0757 36.023 52.0757H35.8182C35.8182 52.0757 35.2036 51.625 35.2036 50.6008C35.2446 49.4946 35.8182 49.0029 35.8182 49.0029Z",
    fill: "url(#paint8_linear_719_2295)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8515 49.0029H34.0564C34.0564 49.0029 33.3599 49.4946 33.3599 50.6008C33.3599 51.625 34.0564 52.0757 34.0564 52.0757H33.8515C33.8515 52.0757 33.155 51.7479 33.155 50.6008C33.155 49.3717 33.8515 49.0029 33.8515 49.0029Z",
    fill: "url(#paint9_linear_719_2295)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1184 33.3932L57.901 55.5171C58.4337 56.4184 58.1059 57.5656 57.2046 58.0982C56.3032 58.6308 55.156 58.303 54.6234 57.4017L41.8408 35.2778C41.3081 34.3765 41.6359 33.2293 42.5372 32.6967C43.4386 32.1641 44.5858 32.4919 45.1184 33.3932Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7906 33.5576L57.6142 55.7634C58.0239 56.4599 57.7781 57.4022 57.0816 57.8119L56.9997 57.8529C56.3032 58.2626 55.3609 58.0167 54.9512 57.3202L42.1275 35.0735C41.7178 34.377 41.9636 33.4347 42.6601 33.025L42.7011 32.984C43.4386 32.5743 44.3809 32.8201 44.7906 33.5576Z",
    fill: "url(#paint10_linear_719_2295)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9226 34.458L55.3608 57.77L55.4428 57.811L55.5247 57.8519L55.6066 57.8929L41.9226 34.2122V34.458Z",
    fill: "url(#paint11_linear_719_2295)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0457 33.6798L56.0984 58.0161H56.2623L42.1276 33.5569L42.0866 33.6388L42.0457 33.6798Z",
    fill: "url(#paint12_linear_719_2295)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6191 33.0653L56.9587 57.8523L57.0816 57.7703L42.7421 32.9834L42.6191 33.0653Z",
    fill: "url(#paint13_linear_719_2295)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6436 32.8195L57.6554 57.1148L57.6144 57.1968L57.5734 57.2787L43.4387 32.7786H43.5207L43.6436 32.8195Z",
    fill: "url(#paint14_linear_719_2295)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3808 33.0658L57.819 56.3368V56.5826L44.135 32.9429L44.217 32.9838L44.2989 33.0248L44.3808 33.0658Z",
    fill: "url(#paint15_linear_719_2295)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2048 55.0255L57.1229 54.8616C57.1229 54.8616 57.041 55.681 56.1396 56.2546C55.2792 56.7872 54.5008 56.4185 54.5008 56.4185L54.5828 56.5824C54.5828 56.5824 55.2383 57.033 56.2216 56.4185C57.2048 55.8449 57.2048 55.0255 57.2048 55.0255ZM56.1806 53.3047L56.0987 53.1409C56.0987 53.1409 55.8938 53.9603 55.0334 54.4519C54.255 54.9436 53.4766 54.6977 53.4766 54.6977L53.5585 54.8616C53.5585 54.8616 54.255 55.1484 55.1563 54.6158C56.0577 54.0832 56.1806 53.3047 56.1806 53.3047Z",
    fill: "#3C98EA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1972 51.585L55.1153 51.4211C55.1153 51.4211 54.7465 52.1176 53.9681 52.5683C53.2716 52.978 52.4932 52.978 52.4932 52.978L52.5751 53.1419C52.5751 53.1419 53.3126 53.1419 54.05 52.7322C54.8285 52.2815 55.1972 51.585 55.1972 51.585Z",
    fill: "#4CA4ED"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M54.214 49.8633L54.1321 49.6995C54.1321 49.6995 53.5994 50.396 52.9029 50.7647C52.2474 51.1334 51.469 51.2563 51.469 51.2563L51.5509 51.4202C51.5509 51.4202 52.3294 51.2973 52.9849 50.9286C53.6404 50.5598 54.214 49.8633 54.214 49.8633Z",
    fill: "#4DA7EE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1577 42.8972L50.2397 43.0611C50.2397 43.0611 49.5432 43.3889 48.8467 43.7576C48.1912 44.1263 47.6176 44.618 47.6176 44.618L47.5356 44.4541C47.5356 44.4541 48.1502 43.9624 48.7647 43.5937C49.4612 43.225 50.1577 42.8972 50.1577 42.8972Z",
    fill: "url(#paint16_linear_719_2295)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1743 41.1775L49.2563 41.3414C49.2563 41.3414 48.4778 41.5872 47.8223 41.9969C47.1668 42.3656 46.6342 42.9392 46.6342 42.9392L46.5522 42.7753C46.5522 42.7753 47.0849 42.2017 47.7404 41.833C48.3959 41.3823 49.1743 41.1775 49.1743 41.1775Z",
    fill: "url(#paint17_linear_719_2295)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3309 39.8262C47.8635 39.6623 48.2732 39.5804 48.2732 39.5804L48.1912 39.4165C48.1912 39.4165 47.8225 39.4575 47.4128 39.6214C47.167 39.7033 47.126 39.9081 47.3309 39.8262Z",
    fill: "#9DD4F7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1836 36.0157L46.2656 36.1796C46.2656 36.1796 45.4871 35.9748 44.5858 36.4664C43.8073 36.9581 43.6435 37.7365 43.6435 37.7365L43.5615 37.5726C43.5615 37.5726 43.6435 36.8761 44.5038 36.3435C45.4052 35.7699 46.1836 36.0157 46.1836 36.0157Z",
    fill: "url(#paint18_linear_719_2295)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2004 34.253L45.3233 34.4169C45.3233 34.4169 44.5039 34.0891 43.5616 34.6217C42.6602 35.1953 42.6602 35.9738 42.6602 35.9738L42.5373 35.8099C42.5373 35.8099 42.4554 35.1134 43.4387 34.4988C44.4629 33.8843 45.2004 34.253 45.2004 34.253Z",
    fill: "url(#paint19_linear_719_2295)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4554 48.6349C46.0199 42.4894 50.1169 35.3606 50.1169 35.3606C50.6495 34.4592 50.3217 33.3121 49.4204 32.7795C48.519 32.2469 47.3719 32.5746 46.8393 33.476C46.8393 33.476 41.8409 42.1616 38.0716 48.6349H42.4554ZM40.2431 52.4042C38.5223 55.354 37.3342 57.4845 37.3342 57.4845C36.8016 58.3858 35.6544 58.7136 34.7531 58.181C33.8517 57.6483 33.524 56.5012 34.0566 55.5998C34.0566 55.5998 34.7531 54.3298 35.8593 52.4451C37.2522 52.4042 39.7924 52.4042 40.2431 52.4042Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0048 48.6346C45.6101 42.4072 49.7891 35.1555 49.7891 35.1555C50.1988 34.459 49.953 33.5167 49.2565 33.107L49.2155 33.066C48.519 32.6563 47.5767 32.9021 47.167 33.5986C47.167 33.5986 42.2506 42.1204 38.4813 48.6346H42.0048ZM39.8333 52.4039C38.1945 55.2718 37.0064 57.3203 37.0064 57.3203C36.5967 58.0168 35.6954 58.2626 34.9579 57.8529H34.876C34.1795 57.4432 33.9336 56.5419 34.3433 55.8044C34.3433 55.8044 35.1218 54.4524 36.3099 52.4039H39.8333Z",
    fill: "url(#paint20_linear_719_2295)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M41.882 48.6333L50.0351 34.5395V34.2937C50.0351 34.2937 45.5283 42.119 41.7591 48.6333H41.882ZM39.6696 52.4025L36.5559 57.8106L36.433 57.8925L36.3101 57.9335C36.3101 57.9335 37.703 55.5162 39.5057 52.4025H39.6696Z",
    fill: "url(#paint21_linear_719_2295)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2672 48.6342L49.8709 33.762L49.83 33.6801L49.789 33.5981C49.789 33.5981 45.0774 41.7512 41.1443 48.5932L41.2672 48.6342ZM39.0958 52.4034L35.8182 58.0573H35.6543C35.6543 58.0573 37.0473 55.6401 38.9319 52.3625C39.0138 52.4034 39.0958 52.4034 39.0958 52.4034Z",
    fill: "url(#paint22_linear_719_2295)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3657 48.6336C44.4218 41.6277 49.2972 33.1469 49.2972 33.1469L49.1743 33.0649L40.1609 48.6336H40.3657ZM38.1533 52.4438C36.3507 55.5985 34.9986 57.9338 34.9986 57.9338L34.8757 57.8519C34.8757 57.8519 36.1868 55.5575 37.9895 52.4438C38.0714 52.4028 38.0304 52.4028 38.1533 52.4438Z",
    fill: "url(#paint23_linear_719_2295)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3825 48.6339C43.4385 41.628 48.4779 32.8604 48.4779 32.8604H48.314C48.314 32.8604 43.2747 41.587 39.2186 48.6339H39.3825ZM37.0062 52.4031C35.3674 55.23 34.2612 57.1556 34.2612 57.1556L34.3022 57.2376L34.3432 57.3195C34.3432 57.3195 35.5313 55.271 37.2111 52.4031H37.0062Z",
    fill: "url(#paint24_linear_719_2295)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7678 48.6343L47.7812 33.0247L47.6993 33.0656L47.6174 33.1066L47.5764 33.1476C47.5764 33.1476 42.578 41.7923 38.6449 48.6343H38.7678ZM36.5964 52.4035C35.1624 54.9027 34.1382 56.6644 34.1382 56.6644V56.3367C34.1382 56.3367 35.0395 54.7798 36.4325 52.3626C36.5145 52.4035 36.5145 52.4035 36.5964 52.4035Z",
    fill: "url(#paint25_linear_719_2295)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7572 34.2536L46.6753 34.4175C46.6753 34.4175 47.4128 34.0487 48.396 34.5813C49.2974 35.073 49.3384 35.9334 49.3384 35.9334L49.4203 35.7695C49.4203 35.7695 49.5022 34.991 48.478 34.4175C47.4537 33.8439 46.7572 34.2536 46.7572 34.2536Z",
    fill: "url(#paint26_linear_719_2295)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7738 36.0149L45.6919 36.1787C45.6919 36.1787 46.5113 35.9329 47.3717 36.4246C48.1911 36.8752 48.355 37.6537 48.355 37.6537L48.4369 37.4898C48.4369 37.4898 48.355 36.7523 47.4536 36.2607C46.5113 35.7281 45.7738 36.0149 45.7738 36.0149Z",
    fill: "url(#paint27_linear_719_2295)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7497 37.7361L44.6677 37.9C44.6677 37.9 45.4052 37.859 46.2246 38.3506C46.9621 38.7603 47.3308 39.4159 47.3308 39.4159L47.4127 39.252C47.4127 39.252 47.044 38.5965 46.3065 38.1868C45.5281 37.7361 44.7497 37.7361 44.7497 37.7361Z",
    fill: "url(#paint28_linear_719_2295)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7665 39.498L43.6846 39.6619C43.6846 39.6619 44.504 39.7848 45.2005 40.1945C45.856 40.5633 46.3476 41.1778 46.3476 41.1778L46.4296 41.0139C46.4296 41.0139 45.9379 40.3994 45.2824 40.0307C44.5859 39.621 43.7665 39.498 43.7665 39.498Z",
    fill: "url(#paint29_linear_719_2295)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7423 41.219L42.6604 41.3829C42.6604 41.3829 43.4388 41.5877 44.1353 41.9974C44.7908 42.3662 45.3235 42.8988 45.3235 42.8988L45.4054 42.7349C45.4054 42.7349 44.8728 42.2023 44.2173 41.8335C43.5617 41.4648 42.7423 41.219 42.7423 41.219Z",
    fill: "url(#paint30_linear_719_2295)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7589 42.9385L41.636 43.1024C41.636 43.1024 42.3734 43.3891 43.0699 43.7988C43.7255 44.1676 44.299 44.6183 44.299 44.6183L44.381 44.4544C44.381 44.4544 43.8074 44.0037 43.1519 43.635C42.4964 43.2662 41.7589 42.9385 41.7589 42.9385Z",
    fill: "url(#paint31_linear_719_2295)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6526 44.8655L40.7345 44.7017L43.3976 46.2176L43.3156 46.3814L40.6526 44.8655Z",
    fill: "url(#paint32_linear_719_2295)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6692 46.6265L39.7511 46.4626C39.7511 46.4626 40.4067 46.9543 41.1031 47.323C41.7587 47.6918 42.4142 47.9785 42.4142 47.9785L42.3322 48.1015C42.3322 48.1015 41.6358 47.8147 40.9802 47.4459C40.2837 47.0772 39.6692 46.6265 39.6692 46.6265Z",
    fill: "url(#paint33_linear_719_2295)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0138 48.635C38.8089 48.4711 38.686 48.3482 38.686 48.3482L38.768 48.1843C38.768 48.1843 39.0138 48.3892 39.3416 48.635H39.0138Z",
    fill: "#73B9F1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M37.416 52.4041C37.5799 52.527 37.7437 52.6499 37.9486 52.7728C38.6861 53.1825 39.4235 53.1415 39.4235 53.1415L39.3416 53.3054C39.3416 53.3054 38.6041 53.3464 37.8667 52.9367C37.5799 52.7728 37.334 52.5679 37.1702 52.4041H37.416Z",
    fill: "url(#paint34_linear_719_2295)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6543 53.5506L35.7362 53.3867C35.7362 53.3867 35.9411 54.2061 36.8424 54.6978C37.6618 55.1484 38.3993 54.9026 38.3993 54.9026L38.3174 55.0665C38.3174 55.0665 37.6618 55.3533 36.7605 54.8616C35.8182 54.329 35.6543 53.5506 35.6543 53.5506Z",
    fill: "url(#paint35_linear_719_2295)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6301 55.3128L34.7121 55.1489C34.7121 55.1489 34.794 56.0093 35.7773 56.5419C36.6786 57.0336 37.3751 56.6648 37.3751 56.6648L37.2522 56.8287C37.2522 56.8287 36.6377 57.2794 35.6544 56.7058C34.6301 56.1322 34.6301 55.3128 34.6301 55.3128Z",
    fill: "url(#paint36_linear_719_2295)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9044 66.2114L65.4396 29.3793L61.0149 27.2898L42.7422 65.5969C42.7422 65.5969 43.3158 65.8837 44.0532 66.2114H47.9044Z",
    fill: "url(#paint37_linear_719_2295)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2699 25.0762L66.4639 28.9683V40.7268C63.6369 39.3748 44.7087 30.3613 44.7087 30.3613C44.7087 30.3613 46.0198 27.6163 47.2489 25.0762H58.2699Z",
    fill: "url(#paint38_radial_719_2295)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9484 64.572C37.8255 64.8179 37.6206 65.1047 37.6616 65.5553C37.7025 67.2351 40.4475 68.792 42.0454 68.792C43.1516 68.792 43.5203 68.3413 43.93 67.5219C44.3397 66.7025 38.399 63.5888 37.9484 64.572Z",
    fill: "url(#paint39_radial_719_2295)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8356 29.7061C56.8356 29.7061 61.0555 30.7303 61.3832 31.0171C61.711 31.3039 60.8506 32.9427 60.6868 33.1885C59.3347 34.8273 55.1148 43.8817 55.1148 43.8817L51.2227 41.6693C51.2227 41.6693 54.7051 35.1961 55.9342 32.9017C56.7127 31.3449 56.8356 29.7061 56.8356 29.7061Z",
    fill: "url(#paint40_linear_719_2295)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5867 27.5753C67.3242 28.1079 68.3075 27.985 69.0859 27.8621C69.6185 27.7802 68.7991 28.5586 67.8978 30.3613C66.9964 32.164 67.0374 32.2869 66.9145 32.164C66.7916 32.0411 62.7355 29.7467 62.8585 29.5419C63.0223 29.337 63.6779 24.8713 64.0056 24.9942C65.1937 25.281 65.3986 26.7149 66.5867 27.5753Z",
    fill: "url(#paint41_linear_719_2295)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2774 32.6141C60.5642 32.1634 61.8752 29.3774 63.9647 29.3774C64.907 29.3774 66.7097 31.7537 66.8736 32.0815C66.9965 32.3683 66.5868 33.5154 66.3819 32.9828C66.1361 32.3683 65.1119 31.0572 64.0057 31.0572C62.8995 31.0572 61.3836 32.3273 61.0149 32.778C60.6461 33.1877 59.9906 33.0648 60.2774 32.6141Z",
    fill: "url(#paint42_linear_719_2295)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1954 32.4518C60.4003 32.124 61.3426 30.6901 61.7932 30.2394C62.2439 29.7887 63.3911 28.6006 64.3744 28.4367C65.3576 28.2729 66.3819 30.2804 66.0541 30.6901C65.8083 30.9769 65.3986 30.6491 64.907 30.2394C64.4153 29.8707 64.0876 29.1332 62.5307 30.3214C61.9981 30.7311 61.4655 31.0588 60.2364 32.8205C59.9086 33.2712 59.9906 32.7796 60.1954 32.4518Z",
    fill: "url(#paint43_linear_719_2295)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M55.115 44.4139C55.2789 44.0861 55.4837 43.5945 55.0331 43.2258C54.5414 42.857 52.2471 41.6279 51.8374 41.546C51.4277 41.464 51.0999 41.546 50.9361 41.8328C50.7722 42.1196 38.1944 63.6699 37.9485 64.2844C37.7027 64.899 37.6617 65.3496 38.0305 65.4725C38.3992 65.5955 42.6191 67.603 43.0288 68.0537C43.4385 68.5043 43.6434 68.0127 43.8073 67.7669C44.5857 66.7836 54.9102 44.7417 55.115 44.4139Z",
    fill: "url(#paint44_linear_719_2295)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4821 32.3685C60.6869 32.0817 61.1786 31.2623 61.7931 30.5248C62.2028 30.0332 64.4152 28.968 64.9068 27.2472C65.1936 26.3049 64.743 25.3626 64.1284 24.9529C62.0389 23.6828 58.4336 21.6753 53.1484 21.6753C49.584 21.6753 48.0681 22.8634 48.0681 22.8634H49.8708L56.1392 25.3216L56.9177 28.5992C56.9177 28.5992 56.9996 29.7054 56.6309 30.9755C56.3851 31.9998 56.3031 32.6143 55.9344 33.6386C56.2212 33.7615 56.8767 33.3108 57.6142 33.5157C58.2697 33.6795 58.6794 34.5809 59.1301 34.0483C59.9085 33.024 60.1543 32.8192 60.4821 32.3685Z",
    fill: "url(#paint45_linear_719_2295)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M56.795 29.8285C56.4672 26.7967 55.7297 23.9288 48.0273 23.9697C48.519 23.4781 49.7071 22.9865 49.7071 22.9865L48.0273 22.8636C48.0273 22.8636 48.2732 22.6587 48.7648 22.6177C53.2715 22.249 57.2866 23.1913 56.9998 29.05C56.9588 29.9924 56.8769 30.4021 56.795 29.8285Z",
    fill: "url(#paint46_linear_719_2295)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0273 23.9701C48.56 23.7653 49.2974 23.6424 50.6904 23.7243C52.4111 23.8062 54.5826 24.4618 55.4839 25.2812C55.9346 25.6909 55.8936 25.3631 55.402 24.8305C54.1319 23.3556 52.2063 23.0278 49.7071 22.9868C49.4203 22.9459 48.478 23.4785 48.0273 23.9701Z",
    fill: "url(#paint47_linear_719_2295)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1679 27.8625L71.4213 29.0097C71.4213 29.0097 70.5609 30.1569 69.8644 31.4679C69.1269 32.8609 68.6353 34.3768 68.6353 34.3768L66.4639 33.0658C66.4639 33.0658 66.9965 31.5908 67.7749 30.1569C68.3895 28.9687 69.1679 27.8625 69.1679 27.8625Z",
    fill: "url(#paint48_linear_719_2295)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4211 29.0097C71.585 29.0917 71.0524 30.3618 70.274 31.8367C69.4955 33.3116 68.7581 34.4588 68.6352 34.3768C68.4713 34.2949 69.0039 33.0248 69.7823 31.5499C70.5198 30.075 71.2573 28.9278 71.4211 29.0097Z",
    fill: "#BFC0D0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_719_2295",
    x1: 45.9164,
    y1: 66.1959,
    x2: 45.9164,
    y2: 25.0696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1578E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C3F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_719_2295",
    x1: 58.2442,
    y1: 52.0618,
    x2: 58.2442,
    y2: 48.9964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1492E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEDFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_719_2295",
    x1: 56.1975,
    y1: 52.0618,
    x2: 56.1975,
    y2: 48.9964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1492E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEDFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_719_2295",
    x1: 45.9161,
    y1: 52.0618,
    x2: 45.9161,
    y2: 48.9964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1492E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEDFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_719_2295",
    x1: 43.8696,
    y1: 52.0618,
    x2: 43.8696,
    y2: 48.9964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1492E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEDFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_719_2295",
    x1: 41.8236,
    y1: 52.0618,
    x2: 41.8236,
    y2: 48.9964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1492E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEDFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_719_2295",
    x1: 39.777,
    y1: 52.0618,
    x2: 39.777,
    y2: 48.9964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1492E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEDFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_719_2295",
    x1: 37.7307,
    y1: 52.0618,
    x2: 37.7307,
    y2: 48.9964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1492E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEDFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_719_2295",
    x1: 35.6346,
    y1: 52.0618,
    x2: 35.6346,
    y2: 48.9964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1492E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEDFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_719_2295",
    x1: 33.5881,
    y1: 52.0618,
    x2: 33.5881,
    y2: 48.9964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1492E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEDFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_719_2295",
    x1: 49.8627,
    y1: 58.0372,
    x2: 49.8627,
    y2: 32.7963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1285E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B5EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_719_2295",
    x1: 55.5509,
    y1: 57.9249,
    x2: 41.8739,
    y2: 34.2351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B90E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B6EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_719_2295",
    x1: 56.2103,
    y1: 58.0681,
    x2: 42.0797,
    y2: 33.5933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3795EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49C4F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_719_2295",
    x1: 57.0103,
    y1: 57.8256,
    x2: 42.6896,
    y2: 33.0215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3696EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90D9F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_719_2295",
    x1: 57.648,
    y1: 57.2508,
    x2: 43.5063,
    y2: 32.7569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3097EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5E5F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_719_2295",
    x1: 57.853,
    y1: 56.5769,
    x2: 44.1928,
    y2: 32.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A98EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCE7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_719_2295",
    x1: 47.5688,
    y1: 44.5057,
    x2: 50.2221,
    y2: 42.9738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9DFF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_719_2295",
    x1: 46.5469,
    y1: 42.7368,
    x2: 49.1997,
    y2: 41.2049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9DFF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_719_2295",
    x1: 43.4509,
    y1: 37.3755,
    x2: 46.0869,
    y2: 35.8539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3E9FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_719_2295",
    x1: 42.4242,
    y1: 35.5956,
    x2: 45.0775,
    y2: 34.0637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3E9FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_719_2295",
    x1: 42.0728,
    y1: 58.0992,
    x2: 42.0728,
    y2: 32.8587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1285E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B5EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_719_2295",
    x1: 36.3842,
    y1: 57.9871,
    x2: 50.0613,
    y2: 34.2982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3194E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71CFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_719_2295",
    x1: 35.7211,
    y1: 58.1319,
    x2: 49.8533,
    y2: 33.6539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AA6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2DEF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_719_2295",
    x1: 34.9241,
    y1: 57.8867,
    x2: 49.2448,
    y2: 33.0826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66ABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE8FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_719_2295",
    x1: 34.2891,
    y1: 57.3121,
    x2: 48.4308,
    y2: 32.8182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BB6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1E3F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_719_2295",
    x1: 34.0792,
    y1: 56.653,
    x2: 47.7464,
    y2: 32.9804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AA6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFE3F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_719_2295",
    x1: 46.9055,
    y1: 34.0442,
    x2: 49.5588,
    y2: 35.5761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1E7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D4F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_719_2295",
    x1: 45.8787,
    y1: 35.8223,
    x2: 48.5319,
    y2: 37.3538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1E7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D4F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_719_2295",
    x1: 44.8205,
    y1: 37.6562,
    x2: 47.4734,
    y2: 39.1877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1E7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D4F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_719_2295",
    x1: 43.7915,
    y1: 39.4386,
    x2: 46.4443,
    y2: 40.9705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52BDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_719_2295",
    x1: 42.7628,
    y1: 41.2206,
    x2: 45.4165,
    y2: 42.7525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4DEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EB5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_719_2295",
    x1: 41.7343,
    y1: 43.0012,
    x2: 44.3871,
    y2: 44.5326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4DEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EB5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_719_2295",
    x1: 40.7095,
    y1: 44.7779,
    x2: 43.3619,
    y2: 46.3093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46AEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_719_2295",
    x1: 39.6835,
    y1: 46.5528,
    x2: 42.3368,
    y2: 48.0847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96CEF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46AAEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_719_2295",
    x1: 37.2189,
    y1: 52.2545,
    x2: 39.2519,
    y2: 53.4283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FC1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3193EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_719_2295",
    x1: 35.5453,
    y1: 53.7214,
    x2: 38.1985,
    y2: 55.2533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FC1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3193EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_719_2295",
    x1: 34.517,
    y1: 55.5025,
    x2: 37.1699,
    y2: 57.0344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FC1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3193EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_719_2295",
    x1: 51.1501,
    y1: 46.0267,
    x2: 56.2537,
    y2: 48.5156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_719_2295",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.7369 29.7181) rotate(116.706) scale(6.6292 11.4709)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_719_2295",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.6963 66.5212) rotate(26.1166) scale(3.23705 1.84263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#0C0C12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D4651"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_719_2295",
    x1: 54.4421,
    y1: 35.4722,
    x2: 58.4424,
    y2: 37.5105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344351"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#9697A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    stopColor: "#8B8C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#787A83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#71747D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#777982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749,
    stopColor: "#87898F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#8E8F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#3D3B42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#606E84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_719_2295",
    x1: 68.0141,
    y1: 31.4089,
    x2: 63.4988,
    y2: 25.3072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#262B33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#74747E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B0B0BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#74747E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_719_2295",
    x1: 60.0898,
    y1: 31.8865,
    x2: 66.7568,
    y2: 31.0253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#606E84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#9899A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#475768"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#262B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_719_2295",
    x1: 63.1977,
    y1: 32.4551,
    x2: 62.5508,
    y2: 28.7866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101215",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#101215",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#474951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#7B7D88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_719_2295",
    x1: 43.5332,
    y1: 52.9033,
    x2: 49.7221,
    y2: 55.9486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#2C3952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#3D414E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#474A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "#4E5057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#323945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#143052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_719_2295",
    x1: 53.1107,
    y1: 32.4009,
    x2: 57.8969,
    y2: 21.8994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#6D7078",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6D7078",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#35363A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#1D1F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#101215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#16171A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#292A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#4B4D51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807,
    stopColor: "#63666B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    stopColor: "#72757B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777A80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_719_2295",
    x1: 48.0126,
    y1: 26.3202,
    x2: 57.0105,
    y2: 26.3202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A4D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29292D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_719_2295",
    x1: 48.0126,
    y1: 24.2147,
    x2: 55.7928,
    y2: 24.2147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#0C0A0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_719_2295",
    x1: 67.3783,
    y1: 33.6623,
    x2: 70.3999,
    y2: 28.4288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#244668"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    stopColor: "#1A3249"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#040506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#313236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    stopColor: "#65656E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607,
    stopColor: "#868691"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#92929E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/appStore.070680b631578edaeeda75429b78465a.svg";
export { ForwardRef as ReactComponent };